//@ts-nocheck

function findNativeInput(form, filterName, filterValue) {
  if (filterName === 'filter.p.tag') {
    return form.querySelector(
      `input[name="${filterName}"][value="${CSS.escape(filterValue)}"]`
    );
  }
  return form.querySelector(`input[name="${filterName}"]`);
}

// Busca el nativo en cualquier form del documento
function findNativeInputGlobal(filterName, filterValue) {
  const forms = document.querySelectorAll('form.facets__form');
  for (const form of forms) {
    const native = findNativeInput(form, filterName, filterValue);
    if (native) return native;
  }
  return null;
}

function syncCustomWithNative(root = document) {
  const customCheckboxes = root.querySelectorAll('.custom-filter-checkbox');

  customCheckboxes.forEach(custom => {
    const name  = custom.dataset.filterName;
    const value = custom.dataset.filterValue;
    if (!name) return;

    const native = findNativeInputGlobal(name, value);
    const listItem = custom.closest('.facets__inputs-list-item');

    if (!native) {
      // El nativo no existe = sin resultados para este valor → ocultar
      if (listItem) listItem.style.display = 'none';
      custom.checked = false;
    } else {
      // Existe → mostrar y sincronizar checked
      if (listItem) listItem.style.display = '';
      custom.checked = native.checked;
    }
  });

  // Después de ocultar items individuales, revisar si un sub-acordeón
  // quedó completamente vacío (todos sus hijos ocultos) → ocultarlo también
  hideEmptySubpanels();
  
  updateCanonical()
}

function hideEmptySubpanels() {
  // Recorre todos los subpanels de adentro hacia afuera
  // para que los niveles más profundos se evalúen primero
  const subpanels = document.querySelectorAll(
    '.facets__item-custom .facets__inputs-list--sub, .facets__item-custom .facets__inputs-list--sub2, .facets__item-custom .facets__inputs-list--sub3'
  );

  // Iterar en orden inverso (más profundo primero)
  const reversed = Array.from(subpanels).reverse();

  reversed.forEach(sublist => {
    const items = sublist.querySelectorAll(':scope > .facets__inputs-list-item');
    const allHidden = Array.from(items).every(
      item => item.style.display === 'none'
    );

    // El <details> padre de esta sublist
    const parentDetails = sublist.closest('details.facets__subpanel');
    const parentLi = parentDetails ? parentDetails.closest('.facets__inputs-list-item') : null;

    if (allHidden && parentLi) {
      parentLi.style.display = 'none';
    } else if (parentLi) {
      parentLi.style.display = '';
    }
  });

  // También revisar el acordeón raíz de Nuestras Categorías:
  // si todos sus hijos directos están ocultos, ocultar el acordeón entero
  const rootGroups = document.querySelectorAll('.facets__item-custom');
  rootGroups.forEach(group => {
    const topList = group.querySelector(':scope > .facets__panel > .facets__inputs > .facets__inputs-wrapper > .facets__inputs-list');
    if (!topList) return;
    const topItems = topList.querySelectorAll(':scope > .facets__inputs-list-item');
    const allHidden = Array.from(topItems).every(
      item => item.style.display === 'none'
    );
    group.style.display = allHidden ? 'none' : '';
  });
}

// Canonical dinámico según filtro activo
function updateCanonical() {
  if (!window.location.pathname.startsWith('/collections/tienda')) return;
  
  const tag = document.querySelector('link[rel="canonical"]');
  if (!tag) return;

  const checkedCategory = document.querySelector('.custom-filter-checkbox[data-filter-canonical]:checked');
  if (checkedCategory) {
    tag.href = `https://beldinbeauty.com${checkedCategory.dataset.filterCanonical}`;
    return;
  }

  const checkedBrand = document.querySelector('input[name="filter.p.m.customAttributes.marca"]:checked');
  if (checkedBrand) {
    const handle = checkedBrand.value.toLowerCase().replace(/\s+/g, '-');
    tag.href = `https://beldinbeauty.com/collections/${handle}`;
    return;
  }

  tag.href = 'https://beldinbeauty.com/collections/tienda';
}

document.addEventListener('click', function (e) {
  const label = e.target.closest('.facets__item-custom .checkbox__label');
  if (!label) return;

  const custom = label.parentElement.querySelector('.custom-filter-checkbox');
  if (!custom) return;

  const name  = custom.dataset.filterName;
  const value = custom.dataset.filterValue;
  if (!name) return;

  const forms = document.querySelectorAll('form.facets__form');
  let native = null;
  let form   = null;

  for (const f of forms) {
    const found = findNativeInput(f, name, value);
    if (found) {
      native = found;
      form   = f;
      break;
    }
  }

  if (!native || !form) return;

  native.checked = !native.checked;
  native.dispatchEvent(new Event('change', { bubbles: true }));
  updateCanonical();
});

document.addEventListener('DOMContentLoaded', () => {
  syncCustomWithNative();
});

document.addEventListener('shopify:section:load', () => {
  syncCustomWithNative();
});

const observer = new MutationObserver(() => {
  syncCustomWithNative();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});